import { useCallback } from 'react';
import { addToast } from '@heroui/react';
import {
  useMarkAsRead,
  useMarkMultipleAsRead,
  useMarkAllAsRead,
} from '@/entities/notification';

export const useNotificationActions = () => {
  const markAsRead = useMarkAsRead();
  const markMultiple = useMarkMultipleAsRead();
  const markAll = useMarkAllAsRead();

  const handleMarkAsRead = useCallback(
    async (id: number) => {
      try {
        await markAsRead.mutateAsync({ path: { id } });
        addToast({
          title: '알림을 읽음 처리했습니다',
          color: 'success',
        });
      } catch (error) {
        console.error('Failed to mark notification as read:', error);
        addToast({
          title: '읽음 처리 실패',
          description: '다시 시도해주세요',
          color: 'danger',
        });
      }
    },
    [markAsRead]
  );

  const handleMarkMultipleAsRead = useCallback(
    async (ids: number[]) => {
      try {
        await markMultiple.mutateAsync({
          body: { notification_ids: ids },
        });
        addToast({
          title: `${ids.length}개 알림을 읽음 처리했습니다`,
          color: 'success',
        });
      } catch (error) {
        console.error('Failed to mark multiple notifications as read:', error);
        addToast({
          title: '읽음 처리 실패',
          description: '다시 시도해주세요',
          color: 'danger',
        });
      }
    },
    [markMultiple]
  );

  const handleMarkAllAsRead = useCallback(async () => {
    try {
      await markAll.mutateAsync({});
      addToast({
        title: '모든 알림을 읽음 처리했습니다',
        color: 'success',
      });
    } catch (error) {
      console.error('Failed to mark all notifications as read:', error);
      addToast({
        title: '읽음 처리 실패',
        description: '다시 시도해주세요',
        color: 'danger',
      });
    }
  }, [markAll]);

  return {
    markAsRead: handleMarkAsRead,
    markMultipleAsRead: handleMarkMultipleAsRead,
    markAllAsRead: handleMarkAllAsRead,
    isLoading:
      markAsRead.isPending || markMultiple.isPending || markAll.isPending,
  };
};
